import SORTS from "../assets/data/sorts.json";
import {TSort, TSorts} from "../types/search";
import * as Constants from "./../constants";
import {ISearchState} from "../types/redux/search";
import {useSelector} from "react-redux";
import {RootState} from "../redux";

export interface IUseSorts {
  getSort (id: string | null): TSort;
  getAvailableSorts (): TSort[];
}

const useSorts = (pageContext: string): IUseSorts => {
  let dbSet: string = useSelector<RootState, ISearchState>((state: RootState):any => state.search).db_set;

  if (pageContext === Constants.SETTINGS) {
    pageContext = Constants.INDUSTRY;
    dbSet = Constants.DOCUMENTS;
  }

  const sortsDB: TSorts = SORTS as TSorts;
  /* @ts-ignore */

  const loadSorts = (): TSort[] =>{
    let sorts: any = sortsDB[pageContext];
    if (pageContext === Constants.INDUSTRY) {
      dbSet = dbSet && (dbSet !== Constants.SEARCHES) ? dbSet : Constants.DOCUMENTS;
      sorts = sorts[dbSet]
    }
    return sorts;
  };


  const getAvailableSorts = (): TSort[] =>{
    return loadSorts()
  }

  const getSort = (id: string | null): TSort => {
    const sorts = loadSorts();
    let returnValue: TSort | undefined = sorts.find(sort=>sort.id === id);
    if (!returnValue) {
      returnValue = loadSorts()[0];
    }
    return returnValue
  }

  return {
    getSort,
    getAvailableSorts
  }
};

export default useSorts;
